import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import { injectModels } from "../redux/injectModels";
import "./loader.css";

const Loader = ({ loader }) => {
  return (
    <React.Fragment>
      {loader.loading ? (
        <React.Fragment>
          <div className="loaded">
            <div id="loader-wrapper" style={{ visibility: "visible" }}>
              <div id="loader" />
              <div className="loader-section section-left" />
              <div className="loader-section section-right" />
            </div>
          </div>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};
// Add PropTypes validation
Loader.propTypes = {
  loader: PropTypes.shape({
    loading: PropTypes.bool.isRequired, // Specify the type and mark it as required
  }).isRequired,
};
export default injectModels(["loader"])(Loader);
